import React, { useState } from "react";
import FormInputText from "../FormInputText";
import {
  FormInputDropdown,
  generateSingleOptions,
} from "../FormComponent/FormInputDropdown";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";

import {
  optionsUserCategory,
  optionsUserType,
} from "../../select-options/options";
import { green } from "@mui/material/colors";
import styled from "@emotion/styled";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FileUpload from "./FileUpload";
import {
  useCreatePostJobApiMutation,
  useCreateProfileApiMutation,
} from "../../services/apiSlice";
import Swal from "sweetalert2";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const defaultValues = {
  personal_description: "",
  job_categories: "",

  profile_title: "",

  hourly_rate_Charge: "",
  experience: "",
};
//

// const imageUploadSchema = object({
//   image: z.instanceof(File),
//   images: array(z.instanceof(File)),
// });
const CreateProfile = () => {
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    register,
    getValues,
    formState: { errors },
  } = methods;

  const navigate = useNavigate();

  const location = useLocation();
  const [createProfileApi, { data, error, isError }] =
    useCreateProfileApiMutation();
  const [errorNumber, setErrorNumber] = useState("");
  const onSubmit = async (data) => {
    let from = location.state?.from?.pathname || "/dashboard";
    console.log({ data });
    const formData = new FormData();

    console.log("it enter image");
    formData.append("image", data.image);
    formData.append("profile_title", data.profile_title);
    formData.append("job_categories", data.job_categories);
    formData.append("personal_description", data.personal_description);
    formData.append("hourly_rate_Charge", data.hourly_rate_Charge);
    formData.append("experience", data.experience);
    try {
      const profileData = await createProfileApi(formData).unwrap();
      console.log(
        { profileData },
        "profileData?.message",
        profileData?.message
      );
      if (profileData?.success === true) {
        // success message
        Swal.fire("Awesome!", `  ${profileData?.message}`, "success").then(
          (result) => {
            if (result.isConfirmed || result.isDismissed) {
              navigate(from);
            }
          }
        );
      } else if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (profileData?.success === false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    } catch (error) {
      if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    }

    console.log(data);
  };

  const [multipleUpload, setMultipleUpload] = useState(false);

  return (
    <>
      <Container maxWidth={"lg"}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          className="min-h-screen"
          sx={{ mt: 5, ml: 4 }}
          style={{
            display: "flex",

            // padding: "20px",
            // margin: "4px 10px",
            flexDirection: "column",
          }}
        >
          <Card
            style={{
              display: "flex",
              gridRowGap: "20px",
              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
            sx={[
              { mx: 3, px: 4 },
              (theme) => ({
                [theme.breakpoints.down("321")]: {
                  width: "100%",
                  py: 3,
                  px: 1,
                  mx: 1,
                },
              }),
            ]}
          >
            <Typography
              variant="h1"
              component="h2"
              className="text-3xl uppercase font-extrabold text-center py-2 md:py-4 "
              sx={{ textAlign: "center" }}
            >
              My Profile
            </Typography>

            <FormControl
              error={Boolean(errors.job_categories)}
              // helperText={errors.user_type?.message}
              size={"small"}
            >
              <InputLabel> What service are you looking for?</InputLabel>

              <Controller
                rules={{
                  required: "Please select   the categories you belong to?",
                }}
                render={({ field }) => (
                  <Select {...field}>
                    {generateSingleOptions(optionsUserCategory)}
                  </Select>
                )}
                name="job_categories"
                control={control}
              />
              <FormHelperText>{errors.job_categories?.message}</FormHelperText>
            </FormControl>

            <TextField
              id="outlined-basic"
              label="How many year's experience do you have?"
              variant="outlined"
              fullWidth
              name="experience"
              size={"small"}
              {...register("experience", {
                required: "hourly rate Charge is Required",
              })}
              error={Boolean(errors.experience)}
              helperText={
                errors.experience &&
                errors.experience.type === "required" &&
                errors.experience.message
              }
            />

            <TextField
              id="outlined-basic"
              label="The hourly rate i charge is:"
              variant="outlined"
              fullWidth
              name="hourly_rate_Charge"
              size={"small"}
              {...register("hourly_rate_Charge", {
                required: "hourly rate Charge is Required",
              })}
              error={Boolean(errors.hourly_rate_Charge)}
              helperText={
                errors.hourly_rate_Charge &&
                errors.hourly_rate_Charge.type === "required"
                  ? errors.hourly_rate_Charge.message
                  : errors.hourly_rate_Charge &&
                    errors.hourly_rate_Charge.type === "pattern" &&
                    errors.hourly_rate_Charge.message
              }
            />

            <TextField
              name="profile_title"
              label="Profile Title"
              variant="outlined"
              fullWidth
              size={"small"}
              {...register("profile_title", {
                required:
                  "Please specify your profile title code or postal code",
              })}
              error={Boolean(errors.profile_title)}
              helperText={
                errors.profile_title && errors.profile_title.type === "required"
                  ? errors.profile_title.message
                  : errors.profile_title &&
                    errors.profile_title.type === "minLength"
                  ? errors.profile_title.message
                  : errors.profile_title &&
                    errors.profile_title.type === "pattern"
                  ? errors.profile_title.message
                  : errors.profile_title &&
                    errors.profile_title.type === "maxLength" &&
                    errors.profile_title.message
              }
            />

            <TextField
              id="outlined-multiline-static"
              label="Personal Description"
              multiline
              rows={4}
              name={"personal_description"}
              {...register("personal_description", {
                required:
                  "Please tell us more about the job to match you with real pro.",
                minLength: {
                  value: 20,
                  message:
                    "Job description  should have at-least 20 characters.",
                },
              })}
              error={Boolean(errors.personal_description)}
              helperText={errors.personal_description?.message}
            />

            <Box
              display="flex"
              flexDirection="column"
              sx={[
                { width: "80%" },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "100%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              {/* Single Image Upload */}
              <FormProvider {...methods}>
                <Stack marginBottom={2}>
                  <Typography
                    textAlign="center"
                    variant="p"
                    component="p"
                    gutterBottom
                    sx={{
                      // mx: 3,
                      py: 3,
                    }}
                  >
                    Click to Upload profile picture
                  </Typography>
                  <FileUpload
                    required={"Profile picture is required"}
                    limit={1}
                    multiple={false}
                    name={"image"}
                  />
                </Stack>
              </FormProvider>
            </Box>

            <Button
              variant="contained"
              type="submit"
              // size="small"
              className="hover:bg-green-300"
              sx={[
                {
                  color: "white",
                  background: green[600],
                  width: "40%",
                  mx: 30,
                  mb: 4,
                  px: 2,
                  py: 2,
                  textAlign: "center",
                  placeItems: "center",
                },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "80%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              Save
            </Button>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default CreateProfile;
